// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyA-qSZOpAkaRAyRyjEXwVGKPFegGeVsH0A",
  authDomain: "litioensudamerica.firebaseapp.com",
  databaseURL: "https://litioensudamerica.firebaseio.com",
  projectId: "litioensudamerica",
  storageBucket: "litioensudamerica.appspot.com",
  messagingSenderId: "62005336191",
  appId: "1:62005336191:web:6b264b4ae655d15d45874a",
  measurementId: "G-96CXPRKJPN"
}
// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/litioensudamerica.appspot.com/o/'